import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = [
        "container",
        "scouttype",
        "brandid",
        "storeid",
        "sentcountsummary",
        "sentcountoption",
        "sentcountdetails",
    ];

    initialize() {
        // connect() は scouttypeValueChanged からも呼ばれるため、
        // ハンドラは初期化時に1度だけ束縛して多重登録を避ける
        this.closeSentCountOnOutsideClick =
            this.closeSentCountOnOutsideClick.bind(this);
        this.closeSentCountOnEscape = this.closeSentCountOnEscape.bind(this);
    }

    static values = {
        scouttype: String,
        brandid: String,
        storeid: String,
    };

    connect() {
        console.log("scout_history_form_controller connect");
        const { brandidTarget, storeidTarget } = this;

        if (this.scouttypeValue == "company") {
            brandidTarget.disabled = true;
            brandidTarget.classList.add("id-disabled");
            brandidTarget.value = "";
            storeidTarget.disabled = true;
            storeidTarget.classList.add("id-disabled");
            storeidTarget.value = "";
        } else if (this.scouttypeValue == "brand") {
            brandidTarget.disabled = false;
            brandidTarget.classList.remove("id-disabled");
            brandidTarget.classList.add("js-no-search");
            storeidTarget.disabled = true;
            storeidTarget.classList.add("id-disabled");
            storeidTarget.value = "";
        } else if (this.scouttypeValue == "store") {
            brandidTarget.disabled = false;
            brandidTarget.classList.remove("id-disabled");
            brandidTarget.classList.remove("js-no-search");
            storeidTarget.disabled = false;
            storeidTarget.classList.remove("id-disabled");
        } else {
            brandidTarget.disabled = true;
            brandidTarget.classList.add("id-disabled");
            brandidTarget.value = "";
            storeidTarget.disabled = true;
            storeidTarget.classList.add("id-disabled");
            storeidTarget.value = "";
        }

        this.refreshSentCountLabel();

        // 他のプルダウンと同様に、要素外クリックと Esc で閉じられるようにする
        document.addEventListener("click", this.closeSentCountOnOutsideClick);
        document.addEventListener("keydown", this.closeSentCountOnEscape);
    }

    disconnect() {
        document.removeEventListener("click", this.closeSentCountOnOutsideClick);
        document.removeEventListener("keydown", this.closeSentCountOnEscape);
    }

    scouttypeValueChanged() {
        this.connect();
    }

    changeSentCount() {
        this.refreshSentCountLabel();
    }

    closeSentCountOnOutsideClick(event) {
        if (!this.hasSentcountdetailsTarget) return;

        const details = this.sentcountdetailsTarget;
        if (!details.open || details.contains(event.target)) return;

        details.open = false;
    }

    closeSentCountOnEscape(event) {
        if (event.key !== "Escape") return;
        if (!this.hasSentcountdetailsTarget) return;

        this.sentcountdetailsTarget.open = false;
    }

    // 送信回数は複数選択のため、選択中の値を開閉部のラベルに反映する
    refreshSentCountLabel() {
        if (!this.hasSentcountsummaryTarget) return;

        const summary = this.sentcountsummaryTarget;
        const selected = this.sentcountoptionTargets.filter(
            (option) => option.checked
        );

        summary.textContent =
            selected.length === 0
                ? summary.dataset.placeholder
                : selected.map((option) => option.dataset.text).join("、");
    }

    changeScoutType(e) {
        console.log(`changeScoutType: ${e.target.value}`);
        $(this.containerTarget).attr(
            "data-scout-history-form-scouttype-value",
            e.target.value
        );
    }

    changeBrandId(e) {
        console.log(`changeBrandId: ${e.target.value}`);
        if (this.scouttypeValue == "store") {
            this.storeidTarget.value = "";
        }
    }
}
